import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  CustomModalOptions,
  ModalAbstractComponent
} from '@bling-fe/shared/modals/base-modal';

export interface VideoModalProps {
  /** A freshly signed url: the opener re-reads the document first. */
  url: string;
  title: string;
}

// HTMLMediaElement.error code of a load the reader stopped.
const MEDIA_ERR_ABORTED = 1;

/**
 * Plays a video of a document list, so the list itself keeps one line per
 * file. The url is signed right before the modal opens, which leaves a
 * failure to the file itself: a format this browser cannot decode, say an
 * iPhone .mov. That ends in the download instead.
 */
@Component({
  selector: 'fl-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  imports: [NgIf, IonicModule, TranslateModule, SvgIconComponent],
  providers: [
    { provide: ModalAbstractComponent, useExisting: VideoModalComponent }
  ]
})
export class VideoModalComponent extends ModalAbstractComponent<
  VideoModalProps,
  void
> {
  public static override modalOptions: CustomModalOptions = {
    cssClass: 'video-modal'
  };

  unplayable = false;

  onError(event: Event) {
    const code = (event.target as HTMLMediaElement | null)?.error?.code;
    if (code !== MEDIA_ERR_ABORTED) {
      this.unplayable = true;
    }
  }
}
